var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
export class SortableUI {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    get isSortableCorrect() {
        return this.question.sortableCheck.isSortableMatchingAnySuccessState;
    }
    get isSortableWrong() {
        return this.question.answer.completeDate && !this.isSortableCorrect;
    }
    get shouldShowTemporaryFalseFeedback_1500ms() {
        if (!this.isSortableWrong)
            return false;
        return this.question.context.app.appClock.clock_250.tickingTime <= this.question.answer.completeDate.getTime() + 1500;
    }
    get hasFalseFeedbackFinished() {
        return this.isSortableWrong && !this.shouldShowTemporaryFalseFeedback_1500ms;
    }
    get visibleSortableState() {
        if (this.hasFalseFeedbackFinished)
            return this.question.sortableStore.successStates[0];
        return this.question.sortableExtractState.currentOverallState;
    }
}
__decorate([
    computed.struct
], SortableUI.prototype, "visibleSortableState", null);
